var React = require('react');

function Lamp2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"lamp-2"),React.createElement("path",{"d":"M179.8,89.9A89.9,89.9,0,0,0,0,89.9c0,1.3,0,2.7.1,4a89.5947,89.5947,0,0,0,24.1,65.3,40.0163,40.0163,0,0,1,11,27.5v21.1a54.7128,54.7128,0,0,0,54.7,54.7h0a54.7128,54.7128,0,0,0,54.7-54.7V186.9a40.7854,40.7854,0,0,1,11.1-27.7A89.6977,89.6977,0,0,0,179.8,98c0-1.3,0-2.6-.1-4C179.8,92.6,179.8,91.3,179.8,89.9Z","style":{"fill":"#edd1a0"},"key":1}),React.createElement("path",{"d":"M89.9,112.9h0a14.98,14.98,0,0,1,15,15v74.9a14.98,14.98,0,0,1-15,15h0a14.98,14.98,0,0,1-15-15V127.9A14.98,14.98,0,0,1,89.9,112.9Z","style":{"fill":"#f0625d"},"key":2})]);
}

Lamp2.defaultProps = {"width":"179.8","height":"auto","viewBox":"0 0 179.8 262.6"};

module.exports = Lamp2;

Lamp2.default = Lamp2;
